import axios from "../common";

export type AuthMeRole = {
  id: number;
  name: string;
  is_active: boolean;
};

export type AuthMeResponse = {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  full_name: string;
  is_active: boolean;
  is_staff: boolean;
  roles: AuthMeRole[];
  permissions: string[];
  profile: {
    avatar: string | null;
    phone: string;
    organization: { id: number; name: string };
  };
};

export const apiFetchMe = () =>
  axios.get<AuthMeResponse>("/auth/me/", { withCredentials: true });
